import AxiosAPI from "./AxiosAPI";

export const fetchMembership = async () => {
  try {
    const response = await AxiosAPI.get("/crm/membership");
    // console.log(response.data)
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const handleEditMembership = async (data) => {
  console.log("membership api key",data.Key);
  
  try {
    const response = await AxiosAPI.put(
      `/crm/membership/${data.key}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const deleteMembership = async (data) => {
  console.log("membership api key for delete",data);
  
  try {
    const response = await AxiosAPI.delete(
      `/crm/membership/${data}`,
      data,{
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const handleAddMembership = async (data) => {
  console.log("Payload to add membership:", data);
  
  try {
    const response = await AxiosAPI.post("/crm/membership", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add membership:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};